module.exports = __webpack_public_path__ + "img/semipublic.1db9e7c0.svg";